import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

export type Theme = 'light' | 'dark';

const DARK_HOST_SUFFIX = '.pacalterkep.hu';
const DARK_HOST_APEX = 'pacalterkep.hu';

/**
 * Host-based forced theme resolver. Pacalterkep.hu (apex + any subdomain) -> dark,
 * everything else (etterem.pacalkereso.hu and subs, localhost, IPs, ...) -> light.
 * Flip to dual-theme by reintroducing localStorage handling here and showing the navbar toggle.
 */
function resolveForcedTheme(): Theme {
  const host =
    typeof globalThis !== 'undefined' && (globalThis as { location?: Location }).location
      ? (globalThis as { location: Location }).location.hostname.toLowerCase()
      : '';
  if (host === DARK_HOST_APEX || host.endsWith(DARK_HOST_SUFFIX)) {
    return 'dark';
  }
  return 'light';
}

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);

  readonly theme = signal<Theme>(resolveForcedTheme());

  constructor() {
    this.applyToDocument(this.theme());
  }

  toggleTheme(): void {
    /* no-op while toggle is hidden; host decides the theme */
  }

  private applyToDocument(theme: Theme): void {
    this.document.documentElement.setAttribute('data-theme', theme);
  }
}
